import React, { createContext, useReducer } from 'react';
import { useUserContext } from './UserContext';


// Объект контекста
export const RolesContext = createContext({});


// Начальное состояние задач
const initialState = {
  roles: [], // Массив задач
  filterBy: '', // Текущий фильтр (статус или другое условие)
  hostname: process.env.REACT_APP_API_URL || "" //process.env.REACT_APP_API_URL
};

// Редюсер для изменения состояния задач
const rolesReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_ROLE':
      return {
        ...state,
        roles: [...state.roles, action.payload.role],
      };
    case 'UPDATE_ROLE':
        debugger
      return {
        ...state,
        roles: state.roles.map(role => {
         return role._id === action.payload.id ? action.payload.UPDrole : role
        }
        ),
      };
    case 'DELETE_ROLE':
      return {
        ...state,
        roles: state.roles.filter(role => role._id !== action.payload.id),
      };
    // case 'FILTER_TASKS':
    //   return {
    //     ...role,
    //     filterBy: action.payload.filterValue,
    //   };
    case 'GET_ROLE':
      return {
        ...state,
        roles: action.payload.roles,
      };
    default:
      return state;
  }
};

// Экспорт самого контекста
export default RolesContext;
export const RolesProvider = ({ children }) => {
  const [role, dispatch] = useReducer(rolesReducer, initialState);
    const {logout} = useUserContext();
  // Методы для манипуляции задачами
  const addRoles = async (credentials) =>{
    try{
    
    const response = await fetch(initialState.hostname+'/roles/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        dispatch({
          type: 'ADD_ROLE',
          payload: { role: {_id:data.data._id, ...credentials} },
        });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

  const editRoles = async (credentials, id) =>{
    try{
    const response = await fetch(initialState.hostname+'/roles/update/' + id, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        dispatch({ type: 'UPDATE_ROLE', payload: { id: id, UPDrole: {...credentials, _id: id} } });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

//   const updateTask = updatedTask => {
//     let id =testTask.findIndex((task)=>{ return task.id === updatedTask.id})
//     testTask[id] = updatedTask
//     dispatch({ type: 'UPDATE_TASK', payload: { id: updatedTask.id, updatedTask } });
//   };

const deleteRole = async id => {
    try {
      const response = await fetch(initialState.hostname+'/roles/delRole/'+ id, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'DELETE_ROLE', payload: { id } });
        return data;
    } catch (error) {
      console.log(error);
    }
    
  };

//   const applyFilter = filterValue => {
//     dispatch({ type: 'FILTER_TASKS', payload: { filterValue } });
//   };

  const getRoles = async () => {
    try {
      const response = await fetch(initialState.hostname+'/roles/getroles', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'GET_ROLE', payload: { roles: data.data } });
        return data;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <RolesContext.Provider value={{
      roles: role.roles,
      filterBy: role.filterBy,
      addRoles,
      editRoles,
      deleteRole,
    //   applyFilter,
      getRoles,
    }}>
      {children}
    </RolesContext.Provider>
  );
};
export const useRolesContext = () => {
  const context = React.useContext(RolesContext);
  if (!context) throw new Error("useRolesContext must be used within a UserProvider");
  return context;
};